<template>
  <div class="button-layout" :style="`text-align: ${align};`">
    <component
      :is="buttonComponent"
      v-for="(btn, index) in buttons"
      :key="btn.label"
      :label="btn.label"
      :type="btn.type"
      :style="`margin-left: ${!index ? '0' : space};`"
      :to="btn.to"
      @click="scrollTo(btn.url)"
    />
  </div>
</template>

<script>
export default {
  name: 'ButtonLayout',
  props: {
    button: {
      type: String,
      default: 'ButtonFlat'
    },
    buttons: {
      type: Array,
      required: true
    },
    space: {
      type: String,
      default: '5vw'
    },
    align: {
      type: String,
      default: 'center'
    }
  },
  methods: {
    scrollTo(url) {
      if (url) this.$scrollTo(url)
    }
  },
  computed: {
    buttonComponent() {
      return () => import(`@/components/shared/button/${this.button}/`);
    }
  }
};
</script>

<style lang="scss" scoped>
.button-layout {
  width: 100%;
  padding: 0 5px;
}
</style>